var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M18,15v1a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H16a2,2,0,0,1,2,2V3H9A2,2,0,0,0,7,5v8a2,2,0,0,0,2,2ZM9,13H19V5H9Zm4-2.5A1.5,1.5,0,1,1,14.5,9,1.5,1.5,0,0,1,13,10.5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }